import { EntityUpdateNotification } from '@core/models/entity-update-notification.model';

export const ENTITY_UPDATES_ACTION_NAME_PREFIX = '[Entity Updates]';

export class UpdateEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Update Entity Updates`;
  constructor(public entityUpdates: EntityUpdateNotification[]) {}
}

export class ClearEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Clear Entity Updates`;
}

export class ListenForEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Listen For Entity Updates`;
  constructor(
    public entityId: string,
    public orgId?: string
  ) {}
}

export class ListenForGenericEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Listen For Generic Entity Updates`;
  constructor(
    public entityType: string,
    public entityId: string
  ) {}
}

export class StopListeningForEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Stop Listening For Entity Updates`;
}

/**
 * Like ListenForGenericEntityUpdates, but each entityType + entityId keeps its own listener,
 * so one screen can watch several push types at once. Updates arrive as KeyedEntityUpdatesReceived
 * and never touch the shared entityUpdates list.
 */
export class ListenForKeyedEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Listen For Keyed Entity Updates`;
  constructor(
    public entityType: string,
    public entityId: string
  ) {}
}

export class StopListeningForKeyedEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Stop Listening For Keyed Entity Updates`;
  constructor(
    public entityType: string,
    public entityId: string
  ) {}
}

export class StopListeningForAllKeyedEntityUpdates {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Stop Listening For All Keyed Entity Updates`;
}

export class KeyedEntityUpdatesReceived {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Keyed Entity Updates Received`;
  constructor(
    public entityType: string,
    public entityId: string,
    public entityUpdates: EntityUpdateNotification[]
  ) {}
}

export class HandleEntityUpdateError {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Handle Entity Update Error`;
  constructor(public entityUpdateErrors: EntityUpdateNotification[]) {}
}

export class ListenForAuditProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Listen For Audit Progress`;
  constructor(public entityId: string) {}
}

export class ListenForFileProcessingProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Listen For File Processing Progress`;
  constructor(public entityId: string) {}
}

export class StopListeningForAuditProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Stop Listening For Audit Progress`;
}

export class StopListeningForFileProcessingProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Stop Listening For File Processing Progress`;
}

export class ListenForScheduleUploadProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Listen For Schedule Upload Progress`;
  constructor(public entityId: string) {}
}

export class StopListeningForScheduleUploadProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Stop Listening For Schedule Upload Progress`;
}

export class ListenForOutboundReportProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Listen For Outbound Report Progress`;
  constructor(public entityId: string) {}
}

export class StopListeningForOutboundReportProgress {
  static readonly type = `${ENTITY_UPDATES_ACTION_NAME_PREFIX} Stop Listening For Outbound Report Progress`;
}
